import { createRoot } from "react-dom/client";
import App from "./app/App";
import registerServiceWorker from "./registerServiceWorker";

import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { CssBaseline } from "@mui/material";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
    <div>
        <I18nextProvider i18n={i18n}>
            <BrowserRouter basename={baseUrl}>
                <SnackbarProvider maxSnack={3}>
                    <CssBaseline />
                    <App />
                </SnackbarProvider>
            </BrowserRouter>
        </I18nextProvider>
    </div>
);

registerServiceWorker();
